export default "__VITE_ASSET__BExzDSwH__"